import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const cipherData = {
    A: 'W', B: 'X', C: 'Y', D: 'Z', E: 'A', F: 'B', G: 'C', H: 'D',
    I: 'E', J: 'F', K: 'G', L: 'H', M: 'I', N: 'J', O: 'K', P: 'L',
    Q: 'M', R: 'N', S: 'O', T: 'P', U: 'Q', V: 'R', W: 'S', X: 'T',
    Y: 'U', Z: 'V'
  };

  const challenges = [
    {
      id: 1,
      riddle: "I speak without a mouth and hear without ears. I have no body, but I come alive with wind. What am I?",
      answer: "ECHO",
      hint: "Can you hears yourself talk?",
      revealCount: 5
    },
    {
      id: 2,
      riddle: "What has two hands on its face but no arms?",
      answer: "CLOCK",
      hint: "Tick Tock...",
      revealCount: 5
    },
    {
      id: 3,
      riddle: "It wears a leather coat to keep its skins in working order. Escorts you to other realms, without a magic portal.",
      answer: "BOOK",
      hint: "Why are you here?",
      revealCount: 5
    },
    {
      id: 4,
      riddle: "I'm tall when I'm young, and I'm short when I'm old. What am I?",
      answer: "CANDLE",
      hint: "It is so romantic...",
      revealCount: 5
    },
    {
      id: 5,
      riddle: "An untiring servant it is, carrying loads across muddy earth. But one thing that cannot be forced, is a return to the place of its birth.",
      answer: "RIVER",
      hint: "It flows",
      revealCount: 6
    }
  ];

  const [revealedLetters, setRevealedLetters] = useState(new Set());
  const [currentChallenge, setCurrentChallenge] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [showHint, setShowHint] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [gameComplete, setGameComplete] = useState(false);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (revealedLetters.size === 26) {
      setGameComplete(true);
      createConfetti();
    }
  }, [revealedLetters]);

  const createConfetti = () => {
    const newParticles = [];
    for (let i = 0; i < 100; i++) {
      newParticles.push({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 3,
        duration: 3 + Math.random() * 2
      });
    }
    setParticles(newParticles);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const challenge = challenges[currentChallenge];
    
    if (userAnswer.toUpperCase().trim() === challenge.answer) {
      setFeedback('Correct! Letters revealed!');
      
      // Reveal random letters
      const allLetters = Object.keys(cipherData);
      const unrevealedLetters = allLetters.filter(letter => !revealedLetters.has(letter));
      const toReveal = Math.min(challenge.revealCount, unrevealedLetters.length);
      
      const newRevealed = new Set(revealedLetters);
      for (let i = 0; i < toReveal; i++) {
        const randomIndex = Math.floor(Math.random() * unrevealedLetters.length);
        newRevealed.add(unrevealedLetters[randomIndex]);
        unrevealedLetters.splice(randomIndex, 1);
      }
      
      setRevealedLetters(newRevealed);
      
      setTimeout(() => {
        if (currentChallenge < challenges.length - 1) {
          setCurrentChallenge(currentChallenge + 1);
          setUserAnswer('');
          setFeedback('');
          setShowHint(false);
        }
      }, 2000);
    } else {
      setFeedback('Not quite right. Try again!');
      setTimeout(() => setFeedback(''), 2000);
    }
  };

  const renderCipherTable = () => {
    const letters = Object.keys(cipherData);
    
    return (
      <div className="cipher-container">
        <h2 className="cipher-title">SECRET CIPHER TABLE </h2>
        <div className="cipher-grid">
          <div className="cipher-row header-row">
            <div className="cipher-label">Cipher Letter</div>
            {letters.map(letter => (
              <div key={`header-${letter}`} className="cipher-cell header-cell">
                {letter}
              </div>
            ))}
          </div>
          <div className="cipher-row">
            <div className="cipher-label">Decoded</div>
            {letters.map(letter => (
              <div 
                key={`decoded-${letter}`} 
                className={`cipher-cell ${revealedLetters.has(letter) ? 'revealed' : 'hidden'}`}
              >
                {revealedLetters.has(letter) ? cipherData[letter] : '?'}
              </div>
            ))}
          </div>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${(revealedLetters.size / 26) * 100}%` }}
          >
            {revealedLetters.size}/26 Letters Revealed
          </div>
        </div>
      </div>
    );
  };

  if (gameComplete) {
    return (
      <div className="App">
        {/* Hidden clues for inspect element */}
        <div style={{ display: 'none' }} data-clue="ciphertext-decoded">
          Ciphertext,Decoded
          GLB MUOELTGDOGIZ,OTHERWORLDLY MAW
          XMQI,LEVEL,
          EGXMGV,FIVE (5),
          TWFKI,TIME,
          HV,30,(Range)
          HYVEXMSR,DURATION
          BDDB,10d6
          BBB,100
        </div>
        <div style={{ display: 'none' }} data-clue="flickering-letters">
          Some of the letters flicker in between one another as you try to read them
          B = 1 or 6
          D = 0
          H = 3
          V = 0
        </div>
        {particles.map(particle => (
          <div
            key={particle.id}
            className="confetti"
            style={{
              left: `${particle.left}%`,
              animationDelay: `${particle.delay}s`,
              animationDuration: `${particle.duration}s`
            }}
          />
        ))}
        <div className="victory-screen">
          <h1 className="victory-title">congrats</h1>
          <p className="victory-message">You've unlocked the entire cipher</p>
          {renderCipherTable()}
          <button 
            className="reset-button"
            onClick={() => {
              setRevealedLetters(new Set());
              setCurrentChallenge(0);
              setGameComplete(false);
              setParticles([]);
              setUserAnswer('');
              setShowHint(false);
              setFeedback('');
              localStorage.clear();
              sessionStorage.clear();
            }}
          >
            Play Again
          </button>
        </div>
      </div>
    );
  }

  const challenge = challenges[currentChallenge];

  return (
    <div className="App">
      {/* Hidden clues for inspect element */}
      <div style={{ display: 'none' }} data-clue="ciphertext-decoded">
        Ciphertext,Decoded
        GLB MUOELTGDOGIZ,OTHERWORLDLY MAW
        XMQI,LEVEL,
        EGXMGV,FIVE (5),
        TWFKI,TIME,
        HV,30,(Range)
        HYVEXMSR,DURATION
        BDDB,10d6
        BBB,100
      </div>
      <div style={{ display: 'none' }} data-clue="flickering-letters">
        Some of the letters flicker in between one another as you try to read them
        B = 1 or 6
        D = 0
        H = 3
        V = 0
      </div>
      <header className="app-header">
        <h1 className="main-title">Secret Cipher Challenge</h1>
        <p className="subtitle">Solve riddles to unlock the cipher table</p>
      </header>

      <div className="game-container">
        <div className="challenge-section">
          <div className="challenge-card">
            <div className="challenge-number">Challenge {currentChallenge + 1} of {challenges.length}</div>
            <div className="riddle-box">
              <p className="riddle-text">{challenge.riddle}</p>
            </div>
            
            <form onSubmit={handleSubmit} className="answer-form">
              <input
                type="text"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                placeholder="Enter your answer..."
                className="answer-input"
                autoFocus
              />
              <div className="button-row">
                <button type="submit" className="submit-button">
                  Submit Answer
                </button>
                <button 
                  type="button" 
                  className="hint-button"
                  onClick={() => setShowHint(!showHint)}
                >
                  {showHint ? 'Hide Hint' : 'Show Hint'}
                </button>
              </div>
            </form>

            {showHint && (
              <div className="hint-box">
                Hint: {challenge.hint}
              </div>
            )}

            {feedback && (
              <div className={`feedback ${feedback.includes('Correct') ? 'success' : 'error'}`}>
                {feedback}
              </div>
            )}
          </div>
        </div>

        {renderCipherTable()}
      </div>
    </div>
  );
};

export default App;
